/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useContent } from '../context/ContentContext';
import { uploadAPI } from '../services/api';
import { 
  RiHomeLine, 
  RiInformationLine, 
  RiServiceLine, 
  RiContactsLine,
  RiSaveLine,
  RiImageLine,
  RiStarLine,
  RiDeleteBinLine,
  RiUploadCloudLine,
} from 'react-icons/ri';
import './ManageContent.css';

const ManageContent = () => {
  const { 
    content, 
    updateHomepage, 
    updateContact, 
    updateContent,
    services,
    features,
    homeImages,
    aboutImages,
    fetchServices,
    fetchFeatures,
    fetchHomeImages,
    fetchAboutImages,
  } = useContent();
  
  const [activeTab, setActiveTab] = useState('homepage');
  const [isSaving, setIsSaving] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  
  const [homepageData, setHomepageData] = useState({
    title: '',
    description: '',
    stats: { pharmacists: 0, projects: 0 }
  });
  
  const [aboutData, setAboutData] = useState({
    title: '',
    description: '',
    services: []
  });
  
  const [servicesData, setServicesData] = useState({
    title: 'Health Care Solutions',
    description: 'We specialize in creating high-quality, custom health services tailored to meet the needs of businesses and individuals.',
    services: []
  });

  const [featuresData, setFeaturesData] = useState({
    features: []
  });

  const [homeImagesData, setHomeImagesData] = useState({
    images: []
  });
  
  const [aboutImagesData, setAboutImagesData] = useState({
    img1: '',
    img2: ''
  });
  
  const [contactData, setContactData] = useState({
    address: '',
    phone: '',
    email: '',
    phone2: '',
    hours: {
      weekday: '',
      saturday: '',
      sunday: ''
    }
  });

  const [selectedFiles, setSelectedFiles] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});

  useEffect(() => {
    if (content?.homepage) {
      setHomepageData({
        title: content.homepage.title || '',
        description: content.homepage.description || '',
        stats: content.homepage.stats || { pharmacists: 0, projects: 0 }
      });
    }

    if (content?.about) {
      setAboutData({
        title: content.about.title || '',
        description: content.about.description || '',
        services: content.about.services || []
      });
    }

    if (content?.contact) {
      setContactData({
        address: content.contact.address || '',
        phone: content.contact.phone || '',
        email: content.contact.email || '',
        phone2: content.contact.phone2 || '',
        hours: content.contact.hours || {
          weekday: '',
          saturday: '',
          sunday: ''
        }
      });
    }
  }, [content]);


  useEffect(() => {
    if (services && services.length > 0) {
      setServicesData(prev => ({
        ...prev,
        services: services
      }));
    }
  }, [services]);

  useEffect(() => {
    if (features && features.length > 0) {
      setFeaturesData({
        features: features
      });
    }
  }, [features]);

  useEffect(() => {
    if (homeImages && homeImages.length > 0) {
      setHomeImagesData({
        images: homeImages
      });
    }
  }, [homeImages]);

  useEffect(() => {
    if (aboutImages) {
      setAboutImagesData({
        img1: aboutImages.img1 || '',
        img2: aboutImages.img2 || ''
      });
    }
  }, [aboutImages]);

  const tabs = [
    { id: 'homepage', label: 'Homepage', icon: <RiHomeLine /> },
    { id: 'about', label: 'About Us', icon: <RiInformationLine /> },
    { id: 'services', label: 'Services', icon: <RiServiceLine /> },
    { id: 'features', label: 'Programs', icon: <RiStarLine /> },
    { id: 'images', label: 'Images', icon: <RiImageLine /> },
    { id: 'contact', label: 'Contact Info', icon: <RiContactsLine /> }
  ];

  const handleFileSelect = (e, type, index = null, field = null) => {
    const file = e.target.files[0];
    if (!file) return;

    const key = field ? `${type}_${field}` : (index !== null ? `${type}_${index}` : type);

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreviews(prev => ({
        ...prev,
        [key]: reader.result
      }));
    };
    reader.readAsDataURL(file);

    setSelectedFiles(prev => ({
      ...prev,
      [key]: file
    }));
  };

const uploadFile = async (file, folder) => {
  try {
    setUploadProgress(prev => ({ ...prev, [folder]: 0 }));
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    
    const response = await uploadAPI.uploadFile(file, folder);
    
    setUploadProgress(prev => ({ ...prev, [folder]: 100 }));
    
    setTimeout(() => {
      setUploadProgress(prev => ({ ...prev, [folder]: 0 }));
    }, 1000);
    

    if (response && response.success) {
      const imageUrl = response.data?.url;
      return imageUrl;
    } else {
      console.error('Upload failed:', response?.error || 'Unknown error');
      return null;
    }
  } catch (error) {
    setUploadProgress(prev => ({ ...prev, [folder]: 0 }));
    return null;
  }
};
const handleSave = async () => {
  setIsSaving(true);
  try {
    const uploadedUrls = {};

    for (const [key, file] of Object.entries(selectedFiles)) {
      if (key.startsWith('service_')) {
        const index = parseInt(key.split('_')[1]);
        const url = await uploadFile(file, 'services');
        if (url) {
          uploadedUrls[`service_${index}`] = url;
        }
      }
    }

    for (const [key, file] of Object.entries(selectedFiles)) {
      if (key.startsWith('feature_')) {
        const index = parseInt(key.split('_')[1]);
        const url = await uploadFile(file, 'features');
        if (url) {
          uploadedUrls[`feature_${index}`] = url;
        }
      }
    }

    for (const [key, file] of Object.entries(selectedFiles)) {
      if (key.startsWith('home_image_')) {
        const index = parseInt(key.split('_')[2]);
        const url = await uploadFile(file, 'home');
        if (url) {
          uploadedUrls[`home_image_${index}`] = url;
        }
      }
    }
    if (selectedFiles.about_img1) {
      const url = await uploadFile(selectedFiles.about_img1, 'about');
      if (url) {
        uploadedUrls.about_img1 = url;
      }
    }
    if (selectedFiles.about_img2) {
      const url = await uploadFile(selectedFiles.about_img2, 'about');
      if (url) {
        uploadedUrls.about_img2 = url;
      }
    }

    const updatedServices = servicesData.services.map((service, index) => {
      if (uploadedUrls[`service_${index}`]) {
        return { ...service, img: uploadedUrls[`service_${index}`] };
      }
      return service;
    });

    const updatedFeatures = featuresData.features.map((feature, index) => {
      if (uploadedUrls[`feature_${index}`]) {
        return { ...feature, image: uploadedUrls[`feature_${index}`] };
      }
      return feature;
    });
    const updatedHomeImages = homeImagesData.images.map((img, index) => {
      if (uploadedUrls[`home_image_${index}`]) {
        return uploadedUrls[`home_image_${index}`];
      }
      return img;
    });


    const updatedAboutImages = { ...aboutImagesData };
    if (uploadedUrls.about_img1) {
      updatedAboutImages.img1 = uploadedUrls.about_img1;
    }
    if (uploadedUrls.about_img2) {
      updatedAboutImages.img2 = uploadedUrls.about_img2;
    }

    switch (activeTab) {
      case 'homepage':
        await updateHomepage(homepageData);
        break;
      case 'about':
        await updateContent('about', aboutData);
        break;
      case 'services':
        await updateContent('services', { 
          ...servicesData, 
          services: updatedServices 
        });
        break;
      case 'features':
        await updateContent('features', { 
          features: updatedFeatures 
        });
        break;
      case 'images':
        await updateContent('home_images', { 
          images: updatedHomeImages 
        });
        await updateContent('about_images', updatedAboutImages);
        break;
      case 'contact':
        await updateContact(contactData);
        break;
      default:
        break;
    }

    setSelectedFiles({});
    setImagePreviews({});

    await fetchServices();
    await fetchFeatures();
    await fetchHomeImages();
    await fetchAboutImages();
    
    alert('Content saved successfully!');
  } catch (error) {
    alert('Error saving content: ' + error.message);
  } finally {
    setIsSaving(false);
  }
};

const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }

  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  
  return imageUrl;
};


  const renderTabContent = () => {
    switch (activeTab) {
      case 'homepage':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>Main Title</label>
              <input
                type="text"
                value={homepageData.title || ''}
                onChange={(e) => setHomepageData({...homepageData, title: e.target.value})}
                placeholder="Enter main title"
              />
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                value={homepageData.description || ''}
                onChange={(e) => setHomepageData({...homepageData, description: e.target.value})}
                placeholder="Enter the description"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label>Statistics</label>
              <div className="stats-grid">
                <div className="stat-input">
                  <label>Total Experts</label>
                  <input
                    type="number"
                    value={homepageData.stats?.pharmacists || 0}
                    onChange={(e) => setHomepageData({
                      ...homepageData,
                      stats: {...homepageData.stats, pharmacists: parseInt(e.target.value) || 0}
                    })}
                  />
                </div>
                <div className="stat-input">
                  <label>Total Projects</label>
                  <input
                    type="number"
                    value={homepageData.stats?.projects || 0}
                    onChange={(e) => setHomepageData({
                      ...homepageData,
                      stats: {...homepageData.stats, projects: parseInt(e.target.value) || 0}
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        );

      case 'about':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>About Title</label>
              <input
                type="text"
                value={aboutData?.title || ''}
                onChange={(e) => setAboutData({...aboutData, title: e.target.value})}
                placeholder="Enter about section title"
              />
            </div>

            <div className="form-group">
              <label>About Description</label>
              <textarea
                value={aboutData?.description || ''}
                onChange={(e) => setAboutData({...aboutData, description: e.target.value})}
                placeholder="Enter about description"
                rows="4"
              />
            </div>

            <div className="form-group">
              <label>Core Values</label>
              <div className="services-list">
                {(aboutData?.services || []).map((service, index) => (
                  <div key={index} className="service-item">
                    <input
                      type="text"
                      value={service || ''}
                      onChange={(e) => {
                        const newServices = [...(aboutData?.services || [])];
                        newServices[index] = e.target.value;
                        setAboutData({...aboutData, services: newServices});
                      }}
                      placeholder="Enter service name"
                    />
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => {
                        const newServices = (aboutData.services || []).filter((_, i) => i !== index);
                        setAboutData({...aboutData, services: newServices});
                      }}
                    >
                      <RiDeleteBinLine />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setAboutData({
                    ...aboutData,
                    services: [...(aboutData.services || []), '']
                  })}
                >
                  Add Value
                </button>
              </div>
            </div>
          </div>
        );

      case 'services':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>Services Title</label>
              <input
                type="text"
                value={servicesData.title || ''}
                onChange={(e) => setServicesData({...servicesData, title: e.target.value})}
                placeholder="Enter services section title"
              />
            </div>

            <div className="form-group">
              <label>Services Description</label>
              <textarea
                value={servicesData.description || ''}
                onChange={(e) => setServicesData({...servicesData, description: e.target.value})}
                placeholder="Enter services description"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label>Service Items</label>
              <div className="services-list-editor">
                {(servicesData.services || []).map((service, index) => (
                  <div key={index} className="service-editor-item">
                    <div className="service-editor-header">
                      <h4>Service #{index + 1}</h4>
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => {
                          const newServices = [...(servicesData.services || [])];
                          newServices.splice(index, 1);
                          setServicesData({...servicesData, services: newServices});
                        }}
                      >
                        <RiDeleteBinLine />
                      </button>
                    </div>
                    <div className="service-editor-fields">
                      <input
                        type="text"
                        placeholder="Service Title"
                        value={service.title || ''}
                        onChange={(e) => {
                          const newServices = [...(servicesData.services || [])];
                          newServices[index] = {...newServices[index], title: e.target.value};
                          setServicesData({...servicesData, services: newServices});
                        }}
                      />
                      
                      <div className="image-upload-field">
                        <label>Service Image</label>
                        <div className="image-upload-container">
                          {(imagePreviews[`service_${index}`] || service.img) && (
                            <div className="image-preview">
                              <img 
                                src={getImageUrl(imagePreviews[`service_${index}`] || service.img)} 
                                alt={`Service ${index + 1}`}
                              />
                            </div>
                          )}
                          <div className="upload-controls">
                            <input
                              type="file"
                              id={`service_img_${index}`}
                              accept="image/*"
                              onChange={(e) => handleFileSelect(e, 'service', index)}
                              style={{ display: 'none' }}
                            />
                            <button
                              type="button"
                              className="btn-upload"
                              onClick={() => document.getElementById(`service_img_${index}`).click()}
                            >
                              <RiUploadCloudLine />
                              {service.img ? 'Change Image' : 'Upload Image'}
                            </button>
                            {uploadProgress[`service_${index}`] > 0 && (
                              <div className="upload-progress">
                                <div 
                                  className="progress-bar" 
                                  style={{ width: `${uploadProgress[`service_${index}`]}%` }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <textarea
                        placeholder="Service Description"
                        value={service.description || ''}
                        onChange={(e) => {
                          const newServices = [...(servicesData.services || [])];
                          newServices[index] = {...newServices[index], description: e.target.value};
                          setServicesData({...servicesData, services: newServices});
                        }}
                        rows="3"
                      />
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    const newServices = [...(servicesData.services || []), { 
                      title: '', 
                      img: '', 
                      description: '' 
                    }];
                    setServicesData({...servicesData, services: newServices});
                  }}
                >
                  Add New Service
                </button>
              </div>
            </div>
          </div>
        );

      case 'features':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>Program</label>
              <div className="features-list-editor">
                {(featuresData.features || []).map((feature, index) => (
                  <div key={index} className="feature-editor-item">
                    <div className="feature-editor-header">
                      <h4>Program #{index + 1}</h4>
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => {
                          const newFeatures = [...(featuresData.features || [])];
                          newFeatures.splice(index, 1);
                          setFeaturesData({...featuresData, features: newFeatures});
                        }}
                      >
                        <RiDeleteBinLine />
                      </button>
                    </div>
                    <div className="feature-editor-fields">
                      <input
                        type="text"
                        placeholder="Program Title"
                        value={feature.title || ''}
                        onChange={(e) => {
                          const newFeatures = [...(featuresData.features || [])];
                          newFeatures[index] = {...newFeatures[index], title: e.target.value};
                          setFeaturesData({...featuresData, features: newFeatures});
                        }}
                      />
                      
                      <input
                        type="text"
                        placeholder="Icon Class (e.g., ri-user-star-line)"
                        value={feature.icon || ''}
                        onChange={(e) => {
                          const newFeatures = [...(featuresData.features || [])];
                          newFeatures[index] = {...newFeatures[index], icon: e.target.value};
                          setFeaturesData({...featuresData, features: newFeatures});
                        }}
                      />

                      <div className="image-upload-field">
                        <label>Program Image</label>
                        <div className="image-upload-container">
                          {(imagePreviews[`feature_${index}`] || feature.image) && (
                            <div className="image-preview">
                              <img 
                                src={getImageUrl(imagePreviews[`feature_${index}`] || feature.image)} 
                                alt={`Feature ${index + 1}`}
                              />
                            </div>
                          )}
                          <div className="upload-controls">
                            <input
                              type="file"
                              id={`feature_img_${index}`}
                              accept="image/*"
                              onChange={(e) => handleFileSelect(e, 'feature', index)}
                              style={{ display: 'none' }}
                            />
                            <button
                              type="button"
                              className="btn-upload"
                              onClick={() => document.getElementById(`feature_img_${index}`).click()}
                            >
                              <RiUploadCloudLine />
                              {feature.image ? 'Change Image' : 'Upload Image'}
                            </button>
                            {uploadProgress[`feature_${index}`] > 0 && (
                              <div className="upload-progress">
                                <div 
                                  className="progress-bar" 
                                  style={{ width: `${uploadProgress[`feature_${index}`]}%` }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <textarea
                        placeholder="Program Description"
                        value={feature.description || ''}
                        onChange={(e) => {
                          const newFeatures = [...(featuresData.features || [])];
                          newFeatures[index] = {...newFeatures[index], description: e.target.value};
                          setFeaturesData({...featuresData, features: newFeatures});
                        }}
                        rows="2"
                      />

                      <textarea
                        placeholder="Program Impact (e.g., '500+ farmers trained')"
                        value={feature.impact || ''}
                        onChange={(e) => {
                          const newFeatures = [...(featuresData.features || [])];
                          newFeatures[index] = {...newFeatures[index], impact: e.target.value};
                          setFeaturesData({...featuresData, features: newFeatures});
                        }}
                        rows="2"
                      />

                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    const newFeatures = [...(featuresData.features || []), { 
                      title: '', 
                      icon: '', 
                      image: '', 
                      description: '' 
                    }];
                    setFeaturesData({...featuresData, features: newFeatures});
                  }}
                >
                  Add New Feature
                </button>
              </div>
            </div>
          </div>
        );

      case 'images':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>Homepage Slideshow Images</label>
              <div className="images-list-editor">
                {(homeImagesData.images || []).map((image, index) => (
                  <div key={index} className="image-editor-item">
                    <div className="image-editor-header">
                      <h4>Slide #{index + 1}</h4>
                      <button
                        type="button"
                        className="remove-btn"
                        onClick={() => {
                          const newImages = (homeImagesData.images || []).filter((_, i) => i !== index);
                          setHomeImagesData({...homeImagesData, images: newImages});
                        }}
                      >
                        <RiDeleteBinLine />
                      </button>
                    </div>
                    
                    <div className="image-upload-field">
                      {(imagePreviews[`home_image_${index}`] || image) && (
                        <div className="image-preview">
                          <img src={getImageUrl(imagePreviews[`home_image_${index}`] || image)}
                            alt={`Slide ${index + 1}`}
                          />
                        </div>
                      )}
                      <div className="upload-controls">
                        <input
                          type="file"
                          id={`home_img_${index}`}
                          accept="image/*"
                          onChange={(e) => handleFileSelect(e, 'home_image', index)}
                          style={{ display: 'none' }}
                        />
                        <button
                          type="button"
                          className="btn-upload"
                          onClick={() => document.getElementById(`home_img_${index}`).click()}
                        >
                          <RiUploadCloudLine />
                          {image ? 'Change Image' : 'Upload Image'}
                        </button>
                        {uploadProgress[`home_image_${index}`] > 0 && (
                          <div className="upload-progress">
                            <div 
                              className="progress-bar" 
                              style={{ width: `${uploadProgress[`home_image_${index}`]}%` }}
                            ></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    const newImages = [...(homeImagesData.images || []), ''];
                    setHomeImagesData({...homeImagesData, images: newImages});
                  }}
                >
                  Add New Slide
                </button>
              </div>
            </div>

            <div className="form-group">
              <label>About Page Images</label>
              <div className="about-images-editor">
            

                <div className="about-image-item">
                  <label>About Us image</label>
                  <div className="image-upload-field">
                    {(imagePreviews.about_img2 || aboutImagesData.img2) && (
                      <div className="image-preview">
                        <img 
                          src={imagePreviews.about_img2 || aboutImagesData.img2} 
                          alt="About Image 2"
                        />
                      </div>
                    )}
                    <div className="upload-controls">
                      <input
                        type="file"
                        id="about_img2"
                        accept="image/*"
                        onChange={(e) => handleFileSelect(e, 'about', 'img2')}
                        style={{ display: 'none' }}
                      />
                      <button
                        type="button"
                        className="btn-upload"
                        onClick={() => document.getElementById('about_img2').click()}
                      >
                        <RiUploadCloudLine />
                        {aboutImagesData.img2 ? 'Change Image' : 'Upload Image'}
                      </button>
                      {uploadProgress.about_img2 > 0 && (
                        <div className="upload-progress">
                          <div 
                            className="progress-bar" 
                            style={{ width: `${uploadProgress.about_img2}%` }}
                          ></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'contact':
        return (
          <div className="content-form">
            <div className="form-group">
              <label>Contact Address</label>
              <input
                type="text"
                value={contactData.address || ''}
                onChange={(e) => setContactData({...contactData, address: e.target.value})}
                placeholder="Enter address"
              />
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>Primary Phone</label>
                <input
                  type="text"
                  value={contactData.phone || ''}
                  onChange={(e) => setContactData({...contactData, phone: e.target.value})}
                  placeholder="Enter primary phone"
                />
              </div>

              <div className="form-group">
                <label>Secondary Phone (Optional)</label>
                <input
                  type="text"
                  value={contactData.phone2 || ''}
                  onChange={(e) => setContactData({...contactData, phone2: e.target.value})}
                  placeholder="Enter secondary phone"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={contactData.email || ''}
                onChange={(e) => setContactData({...contactData, email: e.target.value})}
                placeholder="Enter email"
              />
            </div>

            <div className="form-group">
              <label>Working Hours</label>
              <div className="hours-grid">
                <div className="hour-input">
                  <label>Monday - Friday</label>
                  <input
                    type="text"
                    value={contactData.hours?.weekday || ''}
                    onChange={(e) => setContactData({
                      ...contactData,
                      hours: {...contactData.hours, weekday: e.target.value}
                    })}
                    placeholder="8:00 AM - 6:00 PM"
                  />
                </div>
                <div className="hour-input">
                  <label>Saturday</label>
                  <input
                    type="text"
                    value={contactData.hours?.saturday || ''}
                    onChange={(e) => setContactData({
                      ...contactData,
                      hours: {...contactData.hours, saturday: e.target.value}
                    })}
                    placeholder="9:00 AM - 2:00 PM"
                  />
                </div>
                <div className="hour-input">
                  <label>Sunday</label>
                  <input
                    type="text"
                    value={contactData.hours?.sunday || ''}
                    onChange={(e) => setContactData({
                      ...contactData,
                      hours: {...contactData.hours, sunday: e.target.value}
                    })}
                    placeholder="Emergency Only"
                  />
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="manage-content">
      <div className="page-header">
        <h2>Content Management</h2>
        <button 
          className="btn btn-primary" 
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? (
            <>
              <i className="ri-loader-4-line spin"></i> Saving...
            </>
          ) : (
            <>
              <RiSaveLine /> Save Changes
            </>
          )}
        </button>
      </div>

      <div className="content-tabs">
        <div className="tab-buttons">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>

      <div className="content-preview">
        <h3>Preview Changes</h3>
        <div className="preview-container">
          {activeTab === 'homepage' && (
            <div className="homepage-preview">
              <h2>{homepageData.title || 'Good Health Is The Root Of All Happiness'}</h2>
              <p>{homepageData.description || 'Book your appointment with our pharmacist today for personalized guidance and expert care.'}</p>
              <div className="stats-preview">
                <div className="stat">
                  <h3>{homepageData.stats?.pharmacists || 10}+</h3>
                  <p>Total communities</p>
                </div>
                <div className="stat">
                  <h3>{homepageData.stats?.projects || 22}+</h3>
                  <p>Total Projects</p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="contact-preview">
              <h3>Contact Information Preview</h3>
              <div className="contact-details">
                <p><strong>Address:</strong> {contactData.address || 'South Sudan - Juba, Jebel Suk'}</p>
                <p><strong>Phone:</strong> {contactData.phone || '+211 982332121'}</p>
                {contactData.phone2 && <p><strong>Secondary Phone:</strong> {contactData.phone2}</p>}
                <p><strong>Email:</strong> {contactData.email || 'info@brilliantpharmaceutical.com'}</p>
                <p><strong>Hours:</strong></p>
                <ul>
                  <li>Mon-Fri: {contactData.hours?.weekday || '8:00 AM - 6:00 PM'}</li>
                  <li>Sat: {contactData.hours?.saturday || '9:00 AM - 2:00 PM'}</li>
                  <li>Sun: {contactData.hours?.sunday || 'Emergency Only'}</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageContent;